import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4376" />
      <ArchitectureDiagram data-id="element-4377" />
      <HowItWorksConnections mode="how" data-id="element-4378" />
      <LivesInSlack data-id="element-4379" />
      <ComputerUse data-id="element-4380" />
      <CapabilityGrid data-id="element-4381" />
      <NarrativeSection data-id="element-4382" />
      <ToolComparison data-id="element-4383" />
      <WallOfLove data-id="element-4384" />
      <PricingSection data-id="element-4385" />
      <ClosingCTA data-id="element-4386" />
    </>;
}